import { Type } from "class-transformer";
import { DbTableIdentification } from "./DbTableIdentification";

export class DatabaseValueFound {
    @Type(() => DbTableIdentification)
    tableName: DbTableIdentification;
    columnName: string;
    count = 0;
}
